import Portal from 'components/modal/Portal'

import PropTypes from 'prop-types'
import { AlertCircle, Info, XCircle, CheckCircle, HelpCircle } from 'react-feather'
import { Button, ModalBody, Modal, ModalHeader, ModalFooter } from 'reactstrap'
import { useTranslation } from 'react-i18next'

export const MODAL_ICONS = {
  alert: AlertCircle,
  info: Info,
  error: XCircle,
  success: CheckCircle,
  warn: AlertCircle,
  help: HelpCircle,
}

//sizes : xs,sm,md,lg,xl

export const GenericModal = ({
  show = false,
  title = 'Atenció',
  acceptCb,
  cancelCb,
  children,
  textBtnAccept = 'buttons.accept',
  textBtnCancel = 'buttons.cancel',
  size,
}) => {
  const { t } = useTranslation('common')
  return (
    <Portal>
      <Modal isOpen={show} centered size={size}>
        {title ? <ModalHeader>{title}</ModalHeader> : null}
        <ModalBody>{children}</ModalBody>

        {acceptCb || cancelCb ? (
          <ModalFooter>
            {acceptCb ? (
              <Button
                color="primary"
                onClick={() => {
                  acceptCb()
                }}
              >
                {t(textBtnAccept)}
              </Button>
            ) : null}

            {cancelCb ? (
              <Button
                color="secondary"
                onClick={(evt) => {
                  evt.preventDefault()
                  cancelCb()
                }}
              >
                {t(textBtnCancel)}
              </Button>
            ) : null}
          </ModalFooter>
        ) : null}
      </Modal>
    </Portal>
  )
}

GenericModal.propTypes = {
  show: PropTypes.bool,
  size: PropTypes.string,
  textBtnAccept: PropTypes.string,
  textBtnCancel: PropTypes.string,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  acceptCb: PropTypes.func,
  cancelCb: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
}
